import { render, staticRenderFns } from "./AddPidButton.vue?vue&type=template&id=6885f535&"
import script from "./AddPidButton.vue?vue&type=script&lang=js&"
export * from "./AddPidButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports